/*
 *  I02CHOIXENERCHAUFCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-03-10 14:25:48 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchRendementProduction } from '@batical/data/src'
import { I02CHOIXENERCHAUF_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I02CHOIXENERCHAUF_docalcul(state: I02CHOIXENERCHAUF_State, _isWeb: boolean = false) {
  let selectedrendementProduction_uuid = fetchRendementProduction(state.rendementProduction_uuid)
  state.res_exProdCO2 = (state.in_consommation * selectedrendementProduction_uuid.carbone) / state.in_rendementProduction1 / 1000
  state.res_newProdCO2 = (state.in_consommation * state.in_emiCO2new) / state.in_rendementProduction2 / 1000
  state.res_gainCO2 = state.res_exProdCO2 - state.res_newProdCO2
  if (state.res_exProdCO2 < 1) {
    state.res_exProdCO2 = state.res_exProdCO2 * 1000
    state.unite_exgainco2 = 'g/an'
  } else if (state.res_exProdCO2 > 1000) {
    state.res_exProdCO2 = state.res_exProdCO2 / 1000
    state.unite_exgainco2 = 't/an'
  } else {
    state.unite_exgainco2 = 'kg/an'
  }
  if (state.res_newProdCO2 < 1) {
    state.res_newProdCO2 = state.res_newProdCO2 * 1000
    state.unite_newProdco2 = 'g/an'
  } else if (state.res_newProdCO2 > 1000) {
    state.res_newProdCO2 = state.res_newProdCO2 / 1000
    state.unite_newProdco2 = 't/an'
  } else {
    state.unite_newProdco2 = 'kg/an'
  }
  if (state.res_gainCO2 < 1) {
    state.res_gainCO2 = state.res_gainCO2 * 1000
    state.unite_gainco2 = 'g/an'
  } else if (state.res_gainCO2 > 1000) {
    state.res_gainCO2 = state.res_gainCO2 / 1000
    state.unite_gainco2 = 't/an'
  } else {
    state.unite_gainco2 = 'kg/an'
  }
  state.res_consoAnnuelEstime =
    (state.in_coutNewEnergie * state.in_consommation * state.in_rendementProduction1) / state.in_rendementProduction2
  var etatFinancier = []

  etatFinancier.push(state.in_coutInstallDevis - state.in_aidecredit)
  var prevEtat = etatFinancier[0]
  var nombreAnne = 0
  while (prevEtat > 0 && nombreAnne < 50) {
    prevEtat =
      prevEtat -
      Math.pow(1 + state.in_hausseAncien, nombreAnne) * state.in_ancienneFactureEnergie +
      Math.pow(1 + state.in_hausseNew, nombreAnne) * state.res_consoAnnuelEstime +
      state.in_surcout
    etatFinancier.push(prevEtat)
    if (prevEtat > 0) {
      nombreAnne = nombreAnne + 1
    }
  }
  if (nombreAnne >= 50) {
    state.res_temptri = 0
  } else {
    prevEtat = etatFinancier[nombreAnne]
    var augmentMensuelle =
      (Math.pow(1 + state.in_hausseAncien, nombreAnne) * state.in_ancienneFactureEnergie +
        Math.pow(1 + state.in_hausseNew, nombreAnne) * state.res_consoAnnuelEstime +
        state.in_surcout) /
      12
    var month = 1
    while (prevEtat > 0) {
      prevEtat = prevEtat - augmentMensuelle * month
      etatFinancier.push(prevEtat)
      month++
    }
    month--
    state.res_temptri = nombreAnne + month / 12
  }
  state.invalidated = false
  return state
}

export default I02CHOIXENERCHAUF_docalcul
